import { render, staticRenderFns } from "./new-credit-ticket.vue?vue&type=template&id=e2e05ca6&scoped=true&"
import script from "./new-credit-ticket.vue?vue&type=script&lang=js&"
export * from "./new-credit-ticket.vue?vue&type=script&lang=js&"
import style0 from "./new-credit-ticket.vue?vue&type=style&index=0&id=e2e05ca6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2e05ca6",
  null
  
)

export default component.exports